var AppSandbox = function (core) {
  this.init(core)
}

AppSandbox.prototype.init = function (core) {
  this.publish = core.publish.bind(core)
  this.subscribe = core.subscribe.bind(core)
  this.unsubscribe = core.unsubscribe.bind(core)

  this.resetComponent = core.resetComponent.bind(core)
  this.initializeComponents = core.initializeComponents.bind(core)
  this.deInitializeElementComponents = core.deInitializeElementComponents.bind(core)
  this.deInitializeInstance = core.deInitializeInstance.bind(core)
  this.deInitializeElementInstances = core.deInitializeElementInstances.bind(core)
}

module.exports = AppSandbox



// WEBPACK FOOTER //
// ./assets/js/modules/module-app-sandbox.js